import { render } from "./AddonFields.vue?vue&type=template&id=45871979&scoped=true"
import script from "./AddonFields.vue?vue&type=script&lang=js"
export * from "./AddonFields.vue?vue&type=script&lang=js"

import "./AddonFields.vue?vue&type=style&index=0&id=45871979&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45871979"]])

export default __exports__